<template>
  <div class="component-container-style">
    <MyQuotaInquiryList />
  </div>
</template>
<script type="es6">
import MyQuotaInquiryList from './components/myQuotaInquiryList.vue';
export default {
  data () {
    return {
    };
  },
  components: {
    MyQuotaInquiryList
  }
};
</script>
<style lang="scss" scoped>
.component-container-style{
  background-color: #fff;
  padding: 15px 20px;
}
</style>
